export default __webpack_public_path__ + "static/media/svg-4.198c8835.svg";